// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__jhq84","notes":"Notes_notes__29aOO"};